export function tryGetFlagUrl(countryCode: string) {
  const lowerCaseCountryCode = countryCode.toLowerCase();
  if (!availableFlags[lowerCaseCountryCode]) return null;
  return `https://assets.flynorse.com/static/site/flags/${lowerCaseCountryCode}.svg`;
}

const availableFlags = {
  us: true,
  gb: true,
  no: true,
  de: true,
  fr: true,
  it: true
};
